import {
  ERPSeedless,
  ERPRJL,
  ERPUnity,
  ERPOdoo,
  ERPZertus
} from "src/utils/constants";
import { IRoute } from "src/pages/Router/routes";
import { Icons } from "src/library/components/Icon/types";
import { canViewByRoleCodes } from "src/core/shared/utils/canViewByRoleCodes";

import { AdminMain } from "..";
import AdminOrdersPage from "./AdminOrdersPage";
import ExportOrdersPage from "./ExportOrdersPage";
import ImportOrdersPage from "./ImportOrdersPage";
import OrderImportPage from "./OrderImportPage";
import OrderCallOffsPage from "./CallOffs/OrderCallOffsPage";
import CreateEditOrderCallOffsPage from "./CallOffs/CreateEditCalloffsPage";
import CallOffsRelatedOrderPage from "./CallOffs/CallOffRelatedOrdersPage";

const AdminOrders: IRoute[] = [
  {
    exact: true,
    path: "/admin/orders",
    pageComponent: AdminOrdersPage,
    title: "%ORDERS%",
    icon: Icons.CART,
    menuType: "ADMIN_ORDERS",
    privateRoute: true,
    parent: AdminMain[ 0 ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo,
      ERPZertus
    ],
    permissions: [ "view-order" ],
    roles: [ "admin" ]
  },
  {
    exact: true,
    path: "/admin/orders/export",
    pageComponent: ExportOrdersPage,
    title: "Export",
    icon: Icons.DOWNLOAD,
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "DENY"),
    menuType: "ADMIN_ORDERS",
    privateRoute: true,
    parent: AdminMain[ 0 ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo,
      ERPZertus
    ],
    modules: [ "order-export" ],
    permissions: [ "view-order" ],
    roles: [ "admin" ]
  },
  {
    exact: true,
    path: "/admin/orders/imports",
    canView: store => {
      if (!store.global.settings?.orderImportSettings?.length) {
        return false;
      }

      return canViewByRoleCodes(store, [ "account-manager" ], "DENY");
    },
    pageComponent: ImportOrdersPage,
    title: "Imports",
    icon: Icons.DOWNLOAD,
    menuType: "ADMIN_ORDERS",
    privateRoute: true,
    parent: AdminMain[ 0 ],
    modules: [ "order-import" ],
    permissions: [ "view-order" ],
    roles: [ "admin" ]
  },
  {
    exact: true,
    path: "/admin/orders/call-offs",
    pageComponent: OrderCallOffsPage,
    title: "%CALL-OFFS%",
    icon: Icons.PENDING,
    menuType: "ADMIN_ORDERS",
    privateRoute: true,
    parent: AdminMain[ 0 ],
    modules: [ "call-off" ],
    permissions: [ "view-call-off" ],
    roles: [ "admin" ]
  }

];

const NestedRoutes: IRoute[] = [
  {
    exact: true,
    path: "/admin/orders/imports/:importId",
    pageComponent: OrderImportPage,
    title: "Order Import",
    hidden: true,
    menuType: "ADMIN_ORDERS",
    privateRoute: true,
    parent: AdminOrders[ 2 ],
    modules: [ "order-import" ],
    permissions: [ "create-order" ],
    roles: [ "admin" ]
  },
  {
    exact: true,
    path: "/admin/orders/call-offs/create-edit/:callOffId?",
    pageComponent: CreateEditOrderCallOffsPage,
    title: "Create Edit Call-Off",
    hidden: true,
    menuType: "EMPTY",
    privateRoute: true,
    parent: AdminOrders.find(r => r.title === "%CALL-OFFS%"),
    modules: [ "call-off" ],
    permissions: [ "create-call-off", "amend-call-off" ],
    roles: [ "admin" ]
  },
  {
    exact: true,
    path: "/admin/orders/call-offs/:callOffId",
    pageComponent: OrderImportPage,
    title: "Call-Off",
    hidden: true,
    menuType: "ADMIN_ORDERS",
    privateRoute: true,
    parent: AdminOrders.find(r => r.title === "%CALL-OFFS%"),
    modules: [ "call-off" ],
    permissions: [ "view-call-off" ],
    roles: [ "admin" ]
  },
  {
    exact: true,
    path: "/admin/orders/call-offs/orders/:callOffId",
    pageComponent: CallOffsRelatedOrderPage,
    title: "Call-Off Orders",
    hidden: true,
    menuType: "ADMIN_ORDERS",
    privateRoute: true,
    parent: AdminOrders.find(r => r.title === "%CALL-OFFS%"),
    modules: [ "call-off" ],
    permissions: [ "view-call-off" ],
    roles: [ "admin" ]
  }

  // {
  //   exact: true,
  //   path: "/admin/orders/picking-imports/:importId",
  //   pageComponent: OrderPickImportPage,
  //   title: "Order pick import",
  //   hidden: true,
  //   menuType: "EMPTY",
  //   privateRoute: true,
  //   parent: AdminOrders[ 4 ],
  //   erp: [ ERPSeedless ],
  //   modules: [ "order-import" ],
  //   permissions: [ "create-order" ],
  //   roles: [ "admin" ]
  // },

];

export default [ ...AdminOrders, ...NestedRoutes ];
